// @flow

import LeagueActiveSeason from './LeagueActiveSeason'

export default LeagueActiveSeason
